export default __webpack_public_path__ + "media/images/rank_02-e64e55954ee654d2d5874486c88a3d64.png";